module.exports = __webpack_public_path__ + "static/ads-example-ec78dce144f4c81655eb4eedec1cfe72.jpg";